import { cn } from '@/shared/helpers/cn';
import styles from './Spinner.module.scss';

export interface SpinnerProps {
  /** Tamanho em pixels. Acompanha a altura do controle que o hospeda. */
  size?: number;
  className?: string;
  /** Rotulo lido por leitores de tela. Omita quando o contexto ja anuncia o estado. */
  label?: string;
}

/** Indicador de progresso indeterminado. */
export function Spinner({ size = 16, className, label }: SpinnerProps) {
  return (
    <span
      className={cn(styles.spinner, className)}
      style={{ inlineSize: size, blockSize: size }}
      role={label ? 'status' : undefined}
      aria-hidden={label ? undefined : true}
    >
      {label ? <span className={styles.label}>{label}</span> : null}
    </span>
  );
}
